import { notification } from "antd";
import WhatsAppMensagensService from "../../../services/http/services/WhatsAppMensagens/WhatsAppMensagensService";

export const getMensagensWhatsAppAbertas = () => {
    return WhatsAppMensagensService.getMensagensAbertas()
        .then((response: any) => response?.quantidade ?? null)
        .catch((error: any) => {
            if (error?.message !== 'Requisicao cancelada!') {
                // notification.error({
                //     message: 'Erro',
                //     description: 'Não foi possível buscar o total de mensagens do whatsapp!',
                // });
            }
            return null;
        });
};
